import {Section} from '@primer/react-brand'

import type {PricingSectionProps} from './types'
import {PricingSectionIntro} from './PricingSectionIntro'
import {PricingSectionPlans} from './PricingSectionPlans'
import {PricingSectionCtas} from './PricingSectionCtas'
import {PricingSectionLogos} from './PricingSectionLogos'

export function PricingSection({
  pricingHeading,
  pricingLabel,
  pricingDescription,
  pricingOptions,
  pricingCtas,
  pricingTiles,
  pricingTilesLead,
}: PricingSectionProps) {
  return (
    <Section data-testid="pricing-section" paddingBlockEnd="none">
      <PricingSectionIntro label={pricingLabel} heading={pricingHeading} description={pricingDescription} />

      {pricingOptions && <PricingSectionPlans options={pricingOptions} />}

      {pricingTiles && <PricingSectionLogos tiles={pricingTiles} lead={pricingTilesLead} />}

      {pricingCtas && <PricingSectionCtas ctas={pricingCtas} />}
    </Section>
  )
}
